import { render, staticRenderFns } from "./SentenciasNewOrEdit.vue?vue&type=template&id=eea12dfc&scoped=true"
import script from "./SentenciasNewOrEdit.vue?vue&type=script&lang=js"
export * from "./SentenciasNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./SentenciasNewOrEdit.vue?vue&type=style&index=0&id=eea12dfc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea12dfc",
  null
  
)

export default component.exports